<template>
  <div class="resource-management">
    <p class="rm-tip">关联本预案所需的<strong>应急物资</strong>与<strong>应急专家</strong>（数据来自原页面相同接口：物资分页、专家分页）。</p>
    <el-divider content-position="left">
      <span class="rm-section-title">应急物资</span>
    </el-divider>
    <el-transfer v-model="value" :data="materials" :titles="['待选', '已选']" />
    <el-divider content-position="left">
      <span class="rm-section-title">应急专家</span>
    </el-divider>
    <el-transfer v-model="value2" :data="experts" :titles="['待选', '已选']" />
  </div>
</template>

<script>
import { getDistinctList, getExpertList } from '../../api'

export default {
  props: {
    infoMore: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      materials: [],
      experts: [],
      materialNameMap: {},
      expertNameMap: {},
      value: [],
      value2: []
    }
  },
  watch: {
    infoMore: {
      handler () {
        this.applyPlanSelection()
      },
      deep: true
    }
  },
  mounted () {
    this.loadOptions()
  },
  methods: {
    loadOptions () {
      getDistinctList({
        page: 1,
        size: 1000,
        status: 1
      }).then(({ data }) => {
        if (data.code === 200 && data.data && data.data.records) {
          const map = {}
          this.materials = data.data.records.map(item => {
            map[item.id] = item.materialName
            return {
              key: item.id,
              label: item.materialName
            }
          })
          this.materialNameMap = map
          this.applyPlanSelection()
        }
      })

      getExpertList({
        page: 1,
        size: 1000,
        status: 1
      }).then(({ data }) => {
        if (data.code === 200 && data.data && data.data.records) {
          const map = {}
          this.experts = data.data.records.map(item => {
            map[item.id] = item.expertName
            return {
              key: item.id,
              label: item.expertName
            }
          })
          this.expertNameMap = map
          this.applyPlanSelection()
        }
      })
    },
    applyPlanSelection () {
      const hasDetail = this.infoMore && this.infoMore.id
      const m = this.infoMore && this.infoMore.materials
      const e = this.infoMore && this.infoMore.experts
      if (Array.isArray(m)) {
        this.value = m.map(row => row.materialId).filter(id => id != null)
      } else if (!hasDetail) {
        this.value = []
      }
      if (Array.isArray(e)) {
        this.value2 = e.map(row => row.expertId).filter(id => id != null)
      } else if (!hasDetail) {
        this.value2 = []
      }
    },
    echoData () {
      return {
        materials: this.value.map(id => ({
          materialId: id,
          materialName: this.materialNameMap[id]
        })),
        experts: this.value2.map(id => ({
          expertId: id,
          expertName: this.expertNameMap[id]
        }))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.resource-management {
  padding: 18px 20px 22px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e6edf6;
  box-shadow: 0 3px 12px rgba(31, 45, 61, 0.04);
}
.rm-tip {
  margin: 0 0 12px;
  padding: 10px 12px;
  font-size: 12px;
  color: #526276;
  line-height: 1.55;
  background: #f8fbff;
  border: 1px solid #e8f0fb;
  border-radius: 6px;
}
.rm-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
}
</style>
<style lang="scss">
.resource-management .el-transfer-panel {
  width: 40% !important;
  border-color: #e1e8f0;
  border-radius: 6px;
}
.resource-management .el-transfer-panel__header {
  background: #f8fafc;
}
.resource-management .el-transfer__buttons {
  padding: 0 20px;
}
</style>
